var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"count_common"},[_c('span',{staticClass:"count_common_icon"}),_vm._v(" "),_c('span',{staticClass:"count_common_text"},[_vm._v(_vm._s(_vm.title))])])])}
var staticRenderFns = []

export { render, staticRenderFns }